import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import {
    ToggleTagActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import TagSelector from "~/cabinet/vue/interface/form/tags/TagSelector.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ToggleTagActionBlockForm"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<ToggleTagActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props

let model = _useModel<getActionDescriptionModelType<ToggleTagActionDescription>>(__props, "modelValue");

let frontendParams = props.actionDescription.frontendParams;


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "left",
    "label-width": "240px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { label: "Удалить все имеющиеся тэги" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_switch, {
            modelValue: _unref(model).removeAllTags,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).removeAllTags) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { "label-width": "0" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, "Добавить перечисленные тэги", -1)),
          _createVNode(TagSelector, {
            "tag-type": _unref(frontendParams).tagTypeId,
            modelValue: _unref(model).tagsToAdd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).tagsToAdd) = $event))
          }, null, 8, ["tag-type", "modelValue"])
        ]),
        _: 1
      }),
      (!_unref(model).removeAllTags)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            "label-width": "0"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", null, "Удалить перечисленные тэги", -1)),
              _createVNode(TagSelector, {
                "tag-type": _unref(frontendParams).tagTypeId,
                modelValue: _unref(model).tagsToRemove,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).tagsToRemove) = $event))
              }, null, 8, ["tag-type", "modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})